import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_empty_state = _resolveComponent("empty-state")

  return (_openBlock(), _createBlock(_component_empty_state, {
    title: "There's nothing to show here",
    description: "The resource you're looking for doesn't exist or you don't have permissions to view it."
  }))
}